/** 30 minutes of inactivity re-locks an unlocked location session (Task 2.3; widened from 5 min — owner adjustment). */
export const LOCATION_IDLE_MS = 1_800_000;

/**
 * Fallback tile rotation for groups with no `icon_url` (e.g. new/inactive
 * groups not yet backfilled) — GroupPicker's tile grid and RelockSheet's
 * chip row both use this fixed rotation-by-position in that case.
 */
export const TILE_EMOJI = ['🐬', '⭐', '🐴', '🦁', '🐰', '🐯', '🐨', '🐼', '🦊', '🐸'] as const;
